import useStyles from "../../../style/js-style/containers/thirdparties/sheet/additionalDataStyle.js";
import EAIcon from '../../common/EAIcon';
import EAColorIcon from '../../common/EAColorIcon';
import i18next from 'i18next';
import { PrivilegeEnum, RoleBasedAccessControlContext } from '../../../services/common/RolesUtils';
import React from 'react';

function AdditionalData({ principals, balanceSheetData }) {
  const { classes } = useStyles();
  const {
    hasAnyOfPrivileges
  } = React.useContext(RoleBasedAccessControlContext);

  const Noresult = () => {
    return (
      <div className={classes.emptyWrapper}>
        <EAIcon icon={'search_off'} />
        <div>
          {i18next.t("thirdpartySheet.noResult")}
        </div>
      </div>
    )
  }

  return (
    <div className={classes.container}>
      {/*Dirigeants et mandataires*/}
      {hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_OFFICERS_AGENTS) &&
        <div style={{ flex: 1 }}>
        <div className={classes.title}>
          <EAIcon icon={"thirdparty/mandatory"} style={{ marginRight: '4px' }} />
          {i18next.t("thirdpartySheet.principals")}
        </div>
        {principals && principals.length > 0 ?
          <div className={classes.mandatoryWrapper}>
            {principals.map((entry, index) => (
              <div key={index}>
                <div className={classes.subTitle}>
                  <EAColorIcon icon={entry.companyName ? "thirdparty/domain" : "thirdparty/person"} svgStyle={{ marginRight: '4px' }} />
                  {entry.companyName ? entry.companyName : entry.firstname + " " + entry.name}
                </div>
                <div className={classes.function}>
                  {entry.function}
                </div>
                {index + 1 < principals.length && (
                  <hr style={{ borderTop: "#E2E2EA 1px solid", borderBottom: "none" }} />
                )}
              </div>
              ))}
          </div>
          : <Noresult/>
        }
        </div>
      }

      {/*Finances*/}
      {hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_VIEW_THIRD_PARTY_BALANCE_SHEET) &&
        <div style={{ flex: 1 }}>
          <div className={classes.title}>
            <EAIcon icon={"thirdparty/financial"} style={{ marginRight: '4px' }}/>
            {i18next.t("thirdpartySheet.financial")}
          </div>
          {balanceSheetData && balanceSheetData.length > 0 && !(balanceSheetData.length === 1 && balanceSheetData[0].workforce === "0" && balanceSheetData[0].turnover === "" && balanceSheetData[0].balanceSheetDate === "") ?
            <div className={classes.financeWrapper}>
              {balanceSheetData.map((entry, index) => (
                <div key={index} className={classes.financeItemWrapper}>
                  <div className={classes.financeTurnover}>
                    {entry.turnover || "NC"}
                  </div>
                  <div className={classes.financeDateAndWorkForce}>
                    {entry.balanceSheetDate &&
                      <div>
                        <EAIcon icon={"thirdparty/calendar"} style={{ marginRight: '4px', position: "relative", top: "2px" }} />
                        {entry.balanceSheetDate}
                      </div>
                    }
                    {entry.workforce &&
                      <div>
                        <EAIcon icon={"thirdparty/group"} style={{ marginRight: '4px', position: "relative", top: "2px" }} />
                        {entry.workforce} {i18next.t("thirdpartySheet.persons")}
                      </div>
                    }
                  </div>
                </div>
              ))}
            </div>
            : <Noresult />
          }
        </div>
      }
    </div>
  );
}

export default AdditionalData;
